
/**
 * @export
 * @enum {string}
 */
export enum SeatAssignmentStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE'
}